export default {
  showLoading: state => state.showLoading,
  errorModal: state => state.errorModal,
  consentModal: state => state.consentModal,
  clarifyModal: state => state.clarifyModal,
  kvkkModal: state => state.kvkkModal
}